import React from 'react'
import clsx from 'clsx'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import FullEditor from 'ckeditor5-build-full'

import { configuration } from './editorConfiguration'

// import { uploadSingleFile } from '../../../api/files'
// import { SERVER_URL } from '../../../api'

import './editor.css'

// `config` permite una barra distinta de la de siempre. La usan los textos
// legales: allí el servidor sanea el HTML al guardarlo, así que ofrecer
// colores o alineación sería ofrecer cosas que desaparecen al recargar.
function Editor({ body, setBody, placeholder = '', /* folder = 'unclassified', */ disabled = false, className, lang = 'en', config = configuration }) {
	// function uploadAdapter(loader) {
	// 	return {
	// 		upload: () => {
	// 			return new Promise((resolve, reject) => {
	// 				loader.file
	// 					.then((file) => {
	// 						uploadSingleFile(file/* , folder */)
	// 							.then((res) => {
	// 								resolve({
	// 									default: `${SERVER_URL}/${res.data.fileURL}`
	// 								})
	// 							})
	// 					})
	// 					.catch(error => reject(new Error(error || 'Could not upload image')))
	// 			})
	// 		}
	// 	}
	// }
	// function uploadPlugin(editor) {
	// 	editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
	// 		return uploadAdapter(loader)
	// 	}
	// }

	return (
		<div className={clsx('custom-editor', className)}>
			<CKEditor
				editor={ FullEditor }
				config={{ placeholder, ...config, language: lang }}
				// config = {{ extraPlugins: [uploadPlugin], ...configuration }}
				data={body}
				onChange={ ( event, editor ) => {
					const data = editor.getData()
					setBody(data)
				} }
				disabled={disabled}
			/>
		</div>
	)

}

export default Editor
